import { useNavigate } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { createPlating } from "../../helpers/http_platings_requests";

export default function PlatingNew() {

    const navigate = useNavigate();

    const formFieldList = [
        {
            title: "Formato de Produto",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        createPlating(data, () => navigate('/banhos'))
    };

    return <DynamicFormPage title={"Banhos - Cadastro"} onSubmit={handleSubmit} formFieldList={formFieldList} onCancel={() => navigate(-1)} />;

};
